import type {
  MilkEntity,
  MilkPropsPub,
  MilkPropsPvt,
} from './entity/milkEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MilkJsonPub, MilkJsonPvt } from '@/types/domain/milk/entities/milkEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * ミルクドメインサービス(施設)
 */
export class MilkNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryMilk
   * @param entity entity
   */
  async sendNurseryMilk(
    entity: MilkEntity,
  ) {
    await this.wagakoNurseryApi.send<
      MilkPropsPvt,
      MilkJsonPvt,
      MilkPropsPub,
      MilkJsonPub
    >(entity);
  }

  /**
   * removeNurseryMilk
   * @param entity entity
   */
  async removeNurseryMilk(
    entity: MilkEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      MilkPropsPvt,
      MilkJsonPvt,
      MilkPropsPub,
      MilkJsonPub
    >(entity);
  }
}
